export interface LocalAuthHandler {
  handleLocalAuth: () => Promise<boolean>;
  saveSession: (session: string) => Promise<void>;
  getSession: () => Promise<string | null>;
  removeSession: () => Promise<void>;
}

// Default implementation for web
export const createLocalAuth = (): LocalAuthHandler => ({
  handleLocalAuth: async () => true, // Web doesn't need local auth
  saveSession: async () => {}, // No-op for web
  getSession: async () => null,
  removeSession: async () => {},
}); 